"use client";

import { Box, styled } from "@mui/material";
import { Pencil } from "lucide-react";
import { Button, Tooltip } from "@/ui";

const EditButtonContainer = styled(Box)({
  position: "absolute",
  top: "60px",
  right: "16px",
});

export default function EditButton({ onEdit, disabled, ...props }) {
  const handleEdit = (event) => {
    event.preventDefault();
    if (disabled) return;
    onEdit(event);
  };

  return (
    <Tooltip content={disabled ? "Click Show to allow editing" : "Edit details in modal"}>
      <EditButtonContainer {...props}>
        <Button
          variant="tertiary"
          color="pink"
          size="sm"
          noPadding
          disabled={disabled}
          onClick={handleEdit}
          endIcon={<Pencil size={16} />}
        >
          Edit details
        </Button>
      </EditButtonContainer>
    </Tooltip>
  );
}
